import { render, staticRenderFns } from "./PhotoSearch.vue?vue&type=template&id=6fd53dfc&scoped=true&"
import script from "./PhotoSearch.vue?vue&type=script&lang=js&"
export * from "./PhotoSearch.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSearch.vue?vue&type=style&index=0&id=6fd53dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd53dfc",
  null
  
)

export default component.exports